function Ship({ name, temperature, salinity, speed, lastPort, type, avg_speed, max_speed, distance, product }) {
  // Format temperature and salinity to show up to 3 decimal places
  const formattedTemperature = parseFloat(temperature).toFixed(3);
  const formattedSalinity = parseFloat(salinity).toFixed(3);

  // Check if speed is greater than 100 and divide it by 10 if true
  const displaySpeed = speed > 100 ? (speed / 10).toFixed(2) : speed;

  // Capitalize the first letter of the product name
  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const formattedProduct = capitalizeFirstLetter(product);

  return (
    <div className="ship">
      <h2>{name}</h2>
      <p className="detail">Temperature: {formattedTemperature}</p>
      <p className="detail">Product Applied: {formattedProduct}</p>
      <p className="detail">Salinity: {formattedSalinity}</p>
      <p className="detail">Speed: {displaySpeed}</p>
      <p className="detail">Last Port: {lastPort}</p>
      {/* <p className="detail">Vessel Type: {type}</p> */}
      <p className="detail">Average Speed: {avg_speed}</p>
      <p className="detail">Max Speed: {max_speed}</p>
      <p className="detail">Distance Travelled: {distance} km</p>
    </div>
  );
}

export default Ship;
